import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { Box, HStack } from "@chakra-ui/react";
import { User } from "lucide-react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { mapSource, mapStatus } from "../mappers/screening.mapper";
import { ScreeningFilters } from "../types";

type Props = {
  queryFilters: ScreeningFilters;
  setQueryFilters: Dispatch<SetStateAction<ScreeningFilters>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSearchByDocument = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, tenantDocumentNumber: value })),
    [setQueryFilters]
  );

  const handleSelectStatus = (option: string | undefined) => {
    setQueryFilters((prev) => ({ ...prev, status: option }));
  };

  const handleSelectSource = (option: string | undefined) => {
    setQueryFilters((prev) => ({ ...prev, source: option }));
  };

  return (
    <Box display="flex" gap="1rem">
      <HStack flexGrow={1} position="relative">
        <Box position="absolute" right={3} zIndex={1}>
          <User size={18} color="#9F9DB0" />
        </Box>
        <DebouncedInput
          size="sm"
          placeholder="Buscar por documento"
          _placeholder={{ color: "#5D5C60" }}
          value={queryFilters.tenantDocumentNumber}
          onDebouncedChange={handleSearchByDocument}
        />
      </HStack>
      <SelectFilter
        options={Object.keys(mapStatus)}
        selectedOption={queryFilters.status}
        onSelect={handleSelectStatus}
        placeholder="Todos los estados"
        width="25%"
      />
      <SelectFilter
        options={Object.keys(mapSource)}
        selectedOption={queryFilters.source}
        onSelect={handleSelectSource}
        placeholder="Todos los canales"
        width="25%"
      />
    </Box>
  );
};

export default Filters;
